import $ from 'zepto'
import bus from 'bus'
import user from 'user'
import Overlay from 'overlay'
import {shared as progress} from 'progress'
import 'ui/lightLogin.less'
import ua from 'ua'
import logger, { LOG_ACTION, PAGE_NAME } from "logger"
import store from 'store2'
import checkLoginButton from 'user/widget/checkLoginButton'
import wxapi from 'wxapi'
import alipayAPI from 'alipayAPI'
import tiktokApi from 'tiktokApi'
import VerifyCode from 'VerifyCode'
import {query} from 'qs'
import cookie from 'cookie'
import bridge from 'bridge'
import userService from 'service/user'
import { Dialog } from 'vant'
import ImgVerifyCode from './imgVerifyCode'
var isLight = location.href.indexOf('login.html') === -1

const imgVerifyCode = new ImgVerifyCode(true)
imgVerifyCode.on('cancel', () => {
	imgVerifyCode.hide()
})
let body = $('body')
let $overlay = new Overlay()
let showError = (err) => {
	progress.showMessage(err)
}
var lightLogin
var requesting = false

const tixbayLoginTipText = 'No Mainland China number?'
const tixbayLoginEntryText = 'Start here'
const loginCheckes = `
<div class="login-checkes">
	<div class="login-check checked">
  	<div class="checkbox"></div>
  	<span>已阅读并同意</span>
	</div>
	<a class="rule" href="/agreement.html">《注册协议》</a>
	<a class="rule" href="/about/privacy-agreement.html">《隐私协议》</a>
</div>
`
var $container = $(`
    <div class='${isLight ? 'light-login login mbox' : 'login-page'}'>
			<div class="login-page-bg"></div>
      <div class="top-left-btn close"></div>
			<img width="60px" height="24px" src="https://img.piaoniu.com/img/pic_logo.png" />
      <div class='head'>手机号注册登录</div>
      <div class="titles">
        <div class='title-fast-login select'>快捷登录</div>
        <div class='title-login'>密码登录</div>
      </div>
      <div class='form form-login'>
        <div class='row row-mobile'>
	        <input type='tel' placeholder='请输入手机号' maxlength='13' class='input input-mobile'>
					<img class='input-clear' id='input-clear1' src="https://img.piaoniu.com/img/icon_close.png" />
        </div>
        <div class='row row-password'>
          <input type='password' placeholder='请输入密码' class='input input-password'>
        </div>
        <div class='row row-verify-code hide'>
          <input type='txt' placeholder='请输入图形验证码' class='input input-verify-code'>
          <div class="code-img">
            <img class='verify-img' />
          </div>
        </div>
        <div class='row row-submit'>
          <div class='btn btn-submit unavailable'>登录</div>
        </div>
				<div class="login-tab">
          ${loginCheckes}
        </div>
      </div>
      <div class='form fast-login'>
        <div class='row row-mobile'>
					<input type='tel' placeholder='请输入手机号' maxlength='13' class='input input-mobile'>
					<img style='margin-right: 16px' class='input-clear' id='input-clear2' src="https://img.piaoniu.com/img/icon_close.png" />
        </div>
        <div style='display: flex;' class='row row-getcode'>
          <input style='flex: 1' type='tel' placeholder='请输入验证码' class='input input-getcode'>
					<div style='display: flex; align-items: center'>
						<img class='input-clear' id="clear-code" style="margin-right: 10px" src="https://img.piaoniu.com/img/icon_close.png" />
						<div style='margin-right: 16px' class='btn btn-getcode unavailable'>
							<span>获取验证码</span>
						</div>
					</div>
        </div>
        <div class='hint'></div>
        <div class='row row-submit'>
          <div class='btn btn-submit unavailable'>登录</div>
        </div>
        <div class="login-tab">
          ${loginCheckes}
          <div class='login-btn'>密码登录</div>
				</div>
      </div>
			<div class="tixbay-entry-o-box">
				<div
					class="tixbay-entry"
				>
					<div class="title">${tixbayLoginTipText}</div>
					<div class="entry">
					  ${tixbayLoginEntryText}
						<img
							src='${require('ui/img/tixbay-entry-right-icon.png')}'
							class="right-icon"
							mode="widthFix"
						></img>
					</div>
				</div>
			</div>
			<div
				class="tixbay-poster-mask"
			></div>
			<div class="tixbay-poster">
				<img
					src='${require('ui/img/poster-delete-icon.png')}'
					class="close-icon"
				></img>
				<img
					src='${require('ui/img/tixbay-title.png')}'
					class="title-icon"
					mode="aspectFit"
				></img>
				<img
					src='${require('ui/img/tixbay-desc-poster.png')}'
					class="desc-poster"
					mode="widthFix"
				></img>
				<div class="btn-container">
					<img
					  src='${require('ui/img/tixbay-base-btn.png')}'
						class="btn-item"
						mode="widthFix"
					></img>
				</div>
			</div>
      <div class='wx-login'>
        <img class='icon' src='${require('ui/img/wx-chat.png')}'/>
        <div class='text'>微信登录</div>
      </div>
    </div>
    `)

if (!ua.isMobile()) {
	$container.addClass('pcbox')
} else {
	$container.addClass('mobile-light-box')
}

let $verifyImg = $container.find('.verify-img')
let freshImg = () => {
	let timestamp = new Date().getTime()
	$verifyImg.attr('src', '')
	setTimeout(() => {
		$verifyImg.attr('src', `/api/v1/user/captcha?${timestamp}`)
	}, 50)
	$container.find('.input-verify-code').val('')
	checkLoginButton.checkNormalLogin()
}
$verifyImg.click(() => {
	freshImg()
})

$container.hide()
$container.appendTo(body)
checkLoginButton.init($container)
$container.find('.forget-password').click(() => {
	location.href = '/user/findPassword.html'
})

const closeTixbayPoster = () => {
	$container.find('.tixbay-poster-mask').hide()
	$container.find('.tixbay-poster').hide()
}
$container.find('.close-icon').click(closeTixbayPoster)
$container.find('.tixbay-poster-mask').click(closeTixbayPoster)
$container.find('.btn-container').click(()=>{
	closeTixbayPoster()
	location.href = 'https://m.tixebay.com?channel=piaoniu'
})

$container.find('.tixbay-entry-o-box').click(() => {
	$container.find('.tixbay-poster-mask').show()
	$container.find('.tixbay-poster').show()
})

if (ua.isWechat()) {
	let redir = query.redir || location.href
	$container.find('.tixbay-entry-o-box').addClass('tixbay-entry-o-box-higher')
	$container.find('.wx-login')
		.show()
		.click(() => {
			wxapi.login({
				redir: `/user/login.html?redir=${encodeURIComponent(redir)}`,
				isUserinfoLogin: true
			})
		})
}

// if (ua.isAliPay()) {

// }

var $formLogin = $container.find('.form-login')
var $verifyCode = $container.find('.row-verify-code')

// fastLogin is verifyCodeLogin
var $head = $container.find('.head')
var $fastLogin = $container.find('.fast-login')
var $showVerifyLogin = $container.find('.verify-code-btn')
var $showNormalLogin = $container.find('.login-btn')
var $titleLogin = $('.title-login')
var $titleFastLogin = $('.title-fast-login')
var $fastGetCodeBtn = $fastLogin.find('.btn-getcode')
var $fastMobile = $fastLogin.find('.input-mobile')
var $topLeftBtn = $container.find('.top-left-btn')
var $loginCheck = $container.find('.login-check')

// 这代码改着头大，为了不影响原有功能，时间有限只有这样做了
window.onload = function () {
	const verifyCode = document.querySelector('input[placeholder="请输入验证码"]')
	const [fastMobile, lastMobile] = document.querySelectorAll('.input-mobile')
	const clearnMobile1 = document.querySelector('#input-clear1')
	const clearnMobile2 = document.querySelector('#input-clear2')
	const clerCode = document.querySelector('#clear-code')
	fastMobile.value = ''
	lastMobile.value = ''
	function onInput(e, closeIcon) {		
		const input = e.target;
		let currentValue = input.value;		
		if (currentValue !== '') {
			closeIcon.style.visibility = 'visible';
		} else {
			closeIcon.style.visibility = 'hidden';
		}
		let cleanValue = currentValue.replace(/\D/g, '');
		let formattedValue = formatNumber(cleanValue);
		input.value = formattedValue
	}
	fastMobile.addEventListener('input', (e) => {onInput(e, clearnMobile1)});
	lastMobile.addEventListener('input', (e) => {onInput(e, clearnMobile2)});
	clearnMobile1.addEventListener('click', () => {
		fastMobile.value = ''
		clearnMobile1.style.visibility = 'hidden'
	})
	clearnMobile2.addEventListener('click', () => {
		lastMobile.value = ''
		clearnMobile2.style.visibility = 'hidden'
	})
	verifyCode.addEventListener('input', () => {
		if (verifyCode.value !== '') {
			clearnMobile2.style.visibility = 'hidden'
			clerCode.style.visibility = 'visible';
		} else {
			clerCode.style.visibility = 'hidden';
			if (lastMobile.value !== '') {
				clearnMobile2.style.visibility = 'visible'
			}
		}
	})
	clerCode.addEventListener('click', () => {
		verifyCode.value = ''
		clerCode.style.visibility = 'hidden';
		if (lastMobile.value !== '') {
			clearnMobile2.style.visibility = 'visible'
		}
	})
	// 格式化函数
	function formatNumber(cleanValue) {
		const length = cleanValue.length;
		if (length <= 3) return cleanValue;
		if (length <= 7) return `${cleanValue.slice(0, 3)} ${cleanValue.slice(3)}`;
		return `${cleanValue.slice(0, 3)} ${cleanValue.slice(3, 7)} ${cleanValue.slice(7)}`;
	}
}
	

if (process.browser) {
	const ChannelManager = require('ChannelManager')
	const currentChannel = ChannelManager.current()
	if (currentChannel && currentChannel.loginExtraHintText) {
		if (location.href.indexOf('/login.html') > -1) {
			document.title = '手机号验证'
		}

		$container.find('.head').text('手机号验证')
		$container.find('.btn-submit').text('下一步')
		$container.find('.login-btn').hide()
		$container.find('.hint').show()
		$container.find('.hint').text(currentChannel.loginExtraHintText)
		$topLeftBtn.hide()
	}

	if (ua.isFromqunar()) {
		$container.find('.head').text('手机号验证')
		$container.find('.hint').show()
		$container.find('.hint').text('首次查询订单需手机号验证')
    $container.find('.login-btn').hide()
		$topLeftBtn.hide()
	}
	if (currentChannel && currentChannel.isFromThird) {
    $loginCheck.removeClass('checked')
  }
}

$overlay.on('tap', () => {
	lightLogin.hide()
})

$loginCheck.on('click', function () {
	if ($(this).hasClass('checked')) {
		$(this).removeClass('checked')
	} else {
		$(this).addClass('checked')
	}
})

$titleLogin.add($showNormalLogin).click(function () {
	$head.text('账户密码登录')
	$topLeftBtn.removeClass('close').addClass('back')
	$formLogin.show()
	$fastLogin.hide()
	$(this).addClass('select')
	$titleFastLogin.removeClass('select')
	checkLoginButton.checkNormalLogin()
})

$titleFastLogin.click(function () {
	$formLogin.hide()
	$fastLogin.show()
	$(this).addClass('select')
	$titleLogin.removeClass('select')
	checkLoginButton.checkReg()
})

const showVerifyLogin = () => {
	$head.text('手机快捷登录')
	$topLeftBtn.removeClass('back').addClass('close')
	$formLogin.hide()
	$fastLogin.show()
	$titleLogin.addClass('select')
	$titleFastLogin.removeClass('select')
	checkLoginButton.checkFastLogin()
}

$showVerifyLogin.click(showVerifyLogin)

$topLeftBtn
	.click(() => {
		if ($topLeftBtn.hasClass('close')) {
			if (isLight) {
				lightLogin.hide()
				lightLogin.emit('close')
			} else {
				location.href = query.redir
			}
		} else {
			showVerifyLogin()
		}
	})

function checkLoginCheck($container, callback){
  const checked = $container.find('.login-check').hasClass('checked')
  if (!checked) {
		// progress.showMessage('请阅读并勾选注册协议和隐私协议')
		Dialog({
			title: '同意协议',
			message: '为保障您的合法权益，请您阅读并同意以下协议《注册协议》《隐私协议》',
			confirmButtonText: '同意',
			confirmButtonColor: '#FF2661',
			showCancelButton: true,
			cancelButtonText: '不同意',
			cancelButtonColor: '#262626'
		}).then(() => {
			$loginCheck.click()
			callback && callback()
		}).catch(() => {

		})
  }
  return checked
}

$fastLogin.find('.btn-submit').click(function () {
	if ($(this).hasClass('unavailable')) return
  if (!checkLoginCheck($fastLogin, login)) return	
	function login() {
		var phonenum = $fastMobile.val()
		const phoneValue = phonenum.replaceAll(' ', '')				
		var vcode = $fastLogin.find('.input-getcode').val()
		if (!vcode || !phonenum) return progress.showMessage('手机号或验证码不能为空')

		var data = {
			'ua': phoneValue,
			'code': vcode
		}

		userService.login(data)
			.then(function (user) {
				requesting = false
				lightLogin.emit('login', user)
				logger.onTrack({
					action: LOG_ACTION.click,
					key: 'login_loginBtn',
					keyname: '登录-点击登录',
					schema: PAGE_NAME.loginPage,
					schemaname: "登录页",
					params:{ result: '成功' }
				})
			}).catch(function (err) {
				logger.onTrack({
					action: LOG_ACTION.click,
					key: 'login_loginBtn',
					keyname: '登录-点击登录',
					schema: PAGE_NAME.loginPage,
					schemaname: "登录页",
					params:{ result: '失败' }
				})
			requesting = false
			showError(err)
		})		
	}
	login()
})

$formLogin.find('.btn-submit')
	.click(function () {
		if ($(this).hasClass('unavailable')) return
    if (!checkLoginCheck($formLogin, login)) return
		function login(captcha) {
			var phonenum = $formLogin.find('.input-mobile').val()
			const phoneValue = phonenum.replaceAll(' ', '')
			
			var password = $formLogin.find('.input-password').val()
			// var captcha = $formLogin.find('.input-verify-code').val()

			if (requesting) {
				return
			}
			requesting = true
			userService.login({
					'ua': phoneValue,
					'pw': password,
					'captcha': captcha
				})
				.then((data) => {
					if (data.needCaptcha) {						
						// $verifyCode.removeClass('hide')
						imgVerifyCode.show()
						imgVerifyCode.on('confirm', (captcha) => {
							if (!captcha) return
							login(captcha)
						})
						freshImg()
					} else {
						imgVerifyCode.hide()
						lightLogin.emit('login', data)
					}
					requesting = false
				})
				.catch((err) => {
					console.log('err', err);
					
					if (err === '图形验证码错误') {
						freshImg()
					}
					if (err.includes('该账号已被锁定')){
						Dialog({
							title: '温馨提示',
							message: err,
							confirmButtonText: '知道了',
							confirmButtonColor: '#FF2661',
						})
						imgVerifyCode.hide()
					} else {
						showError(err)
					}
					requesting = false
				})
		}
		login()
	})

new VerifyCode($fastGetCodeBtn, $fastMobile, '/v3/user/sendLoginCode')

let normalAssureLogin = (cb) => {
	return new Promise((resolve, reject) => {
		let logged = user.isLoginSync()
		if (logged) {
			user.get()
				.then(function (user) {
					cb && cb(user)
					resolve(user)
				}, () => {
					lightLogin.emit('popLogin')
					lightLogin.once('login', (user) => {
						cb && cb(user)
						resolve(user)
					})
					lightLogin.once('close', () => {
						reject()
					})
					lightLogin.show()
				})
		} else {
			const ChannelManager = require('ChannelManager')
			const currentChannel = ChannelManager.current()
			if (currentChannel && currentChannel.login) {
				return currentChannel.login()
			} else {
				lightLogin.emit('popLogin')
				lightLogin.once('login', (user) => {
					cb && cb(user)
					resolve(user)
				})
				lightLogin.once('close', () => {
					reject()
				})
				lightLogin.show()
			}
		}
	})
}

let miniProgramLogin = (cb) => {
  return new Promise((resolve, reject) => {
    const { pner, pnid, cityId } = query
    if (pner) {
      cookie.set('pner', pner, 8760, '.piaoniu.com', '/');
      cookie.set('pnid', pnid, 8760, '.piaoniu.com', '/');
	  cookie.set('cityId', cityId, 24 * 365, '.piaoniu.com', '/')
      user.get()
        .then(function (user) {
		  cb && cb(user)
          resolve(user)
        })
        .catch(err => {
          reject(err)
        })
    } else {
      user.logout().then(() => {
        if (ua.isPiaoniuMiniProgram()) {
          wxapi.load().then(() => {
            wx.miniProgram.navigateTo({
              url: `/pages/bind-phone/index?redirect=${encodeURIComponent(location.href)}`
            })
          })
        }
        if (ua.isPiaoniuAliMiniProgram()) {
          alipayAPI.load().then(() => {
            my.navigateTo({
              url: `/pages/bind-phone/index?redirect=${encodeURIComponent(location.href)}`
            })
          })
		}
		if(ua.isPiaoniuTiktokMiniProgram()) {
		  tiktokApi.load().then(() => {
			tt.navigateTo({
			  url: `/pages/bind-phone/index?redirect=${encodeURIComponent(location.href)}`
			})
		  })
		}
      })
    }
  })
}

let thirdMiniProgramLogin = (cb) => {
  return new Promise((resolve, reject) => {
    const { pner, pnid, cityId } = query
    if (pner) {
      cookie.set('pner', pner, 8760, '.piaoniu.com', '/');
      cookie.set('pnid', pnid, 8760, '.piaoniu.com', '/');
      cookie.set('cityId', cityId, 24 * 365, '.piaoniu.com', '/')
      user.get()
        .then(function (user) {
          cb && cb(user)
          resolve(user)
        })
        .catch(err => {
          reject(err)
        })
    } else {
      const userData = store.session.get('user')
      if (userData) {
        cb && cb(userData)
        resolve(userData)
      } else {
        user.logout().then(() => {
          lightLogin.emit('popLogin')
          lightLogin.once('login', (user) => {
            store.session.set('user', user)
            cb && cb(user)
            resolve(user)
          })
          lightLogin.once('close', () => {
            reject()
          })
          lightLogin.show()
        })
      }
    }
  })
}

let nativeAssureLogin = (cb) => {
	return new Promise(function (resolve) {
		bridge.assureLogin(function (dict) {
			let user = dict.user
			let pner = dict.token

			const sensors = require('sensors')
			sensors.login(user.userId)

			cookie.set('pner', pner, 24 * 365, '.piaoniu.com', '/')
			cookie.set('pnid', user.userId, 24 * 365, '.piaoniu.com', '/')
			cb && cb(user)
			resolve(user)
		})
	})
}

let useNativeAssureLogin = () => {
	let iOSSupport = ua.versionGreaterThanOrEqualTo('5.16.0')
	let AndroidSupport = ua.versionGreaterThanOrEqualTo('5.15.1')
	if (ua.isPiaoniu()) {
		return (ua.isIOS() && iOSSupport) || (ua.isAndroid() && AndroidSupport)
	} else {
		return false
	}
}

let useMiniProgramLogin = () => {
  return ua.isPiaoniuMiniProgram() || ua.isPiaoniuAliMiniProgram() || ua.isPiaoniuTiktokMiniProgram()
}

let useThirdMiniProgramLogin = () => {
  return ua.isThirdMiniProgram()
}

let assureLogin = ''
if (useNativeAssureLogin()) {
	assureLogin = nativeAssureLogin
} else if (useMiniProgramLogin()) {
	assureLogin = miniProgramLogin
} else if (useThirdMiniProgramLogin()) {
	assureLogin = thirdMiniProgramLogin
} else {
	assureLogin = normalAssureLogin
}

// let assureLogin = useNativeAssureLogin() ? nativeAssureLogin : normalAssureLogin

lightLogin = {
	platform: 'mobile',
	$overlay: $overlay,
	assureLogin: assureLogin,
	show: () => {
		logger.sendPV('/user/login.html')
		logger.onTrack({
			action: LOG_ACTION.enter,
			key: 'login_page',
			keyname: '登录',
			schema: PAGE_NAME.loginPage,
			schemaname: "登录页"
		})
		$container.find('.input:eq(0)')
			.focus()
		$overlay.show()
		$container.show()
		const sensors = require('sensors')
		sensors.track('Login',{})
	},
  container: $container,
	hide: () => {
		$overlay.hide()
		$container.hide()
	}
}

bus.mixin(lightLogin)

lightLogin.on('login', () => {
	if (isLight) {
		$formLogin.find('input')
			.blur()
		lightLogin.hide()
	}
})

module.exports = lightLogin



// WEBPACK FOOTER //
// ./src/mods/lightLogin.js